import { useState, useEffect, use } from "react"
import { useCookies } from "react-cookie"
import API from "../services/ApiService"
import { useAuth } from '../context/AuthContext';
import { safeApiCall } from "../utils/safeApiCall";
import { toast } from "react-toastify";
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary";

export default function LoginForm( { setLoginModalOpen } ){
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const { contextLogin } = useAuth();
    const [user, setUser] = useCookies(["user"])
    const [registrationMode, setRegistrationMode] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmEmail, setConfirmEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [emailMatchError, setEmailMatchError] = useState("");
    const [passwordMatchError, setPasswordMatchError] = useState("");
    const [username, setUsername] = useState("");
    const [usernameError, setUsernameError] = useState("");

    useEffect(() => {
        if (registrationMode) {
            const timeout = setTimeout(() => {
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!emailRegex.test(email)) {
                    setEmailError("Please enter a valid email address.");
                } else {
                    setEmailError("");
                }
                if (confirmEmail !== "") {
                    if (email === confirmEmail) {
                        setEmailMatchError("");
                    } else {
                        setEmailMatchError("Email addresses do not match.");
                    }
                }
            }, 1500);

            return () => clearTimeout(timeout);
        }
    }, [email])

    useEffect(() => {
        if (registrationMode) {
            const timeout = setTimeout(() => {
                if (email !== confirmEmail) {
                    setEmailMatchError("Email addresses do not match.");
                } else {
                    setEmailMatchError("");
                }
            }, 1500);

            return () => clearTimeout(timeout);
        }
    }, [confirmEmail])

    useEffect(() => {
        if (registrationMode) {
            const timeout = setTimeout(() => {
                if (password.length < 8) {
                    setPasswordError("Password must be at least 8 characters long.");
                    if (password.length > 32) {
                        setPasswordError("The password is too long.");
                    }
                } else {
                    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
                    if (!passwordRegex.test(password)) {
                        setPasswordError("Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.");
                    } else {
                        setPasswordError("");
                    }
                }
                if (confirmPassword !== "") {
                    if (password === confirmPassword) {
                        setPasswordMatchError("");
                    } else {
                        setPasswordMatchError("Passwords do not match.");
                    }
                }
            }, 1500);

            return () => clearTimeout(timeout);
        }
    }, [password])

    useEffect(() => {
        if (registrationMode) {
            const timeout = setTimeout(() => {
                if (password !== confirmPassword) {
                    setPasswordMatchError("Passwords do not match.");
                }
                else {
                    setPasswordMatchError("");
                }
            }, 1500);

            return () => clearTimeout(timeout);
        }
    }, [confirmPassword])

    useEffect(() => {
        if (registrationMode) {
            const timeout = setTimeout(() => {
                if (username.length < 5) {
                    setUsernameError("Username must be at least 3 characters long.");
                } else {
                    if (username.length > 16) {
                        setUsernameError("Username must be less than 16 characters long.");
                    } else {
                        const usernameRegex = /^[a-zA-Z0-9_]+$/;
                        if (!usernameRegex.test(username)) {
                            setUsernameError("Username can only contain letters, numbers, and underscores.");
                        } else {
                            setUsernameError("");
                        }
                    }
                }
            }, 1500);

            return () => clearTimeout(timeout);
        }
    }, [username])


    const handleRegistration = async (e) => {
        e.preventDefault();
        if (emailError!== "" || passwordError!== "" || emailMatchError!== "" || passwordMatchError!== ""){
            toast.error("Please fix the errors in the form before submitting.");
            return;
        } else {
            try {
                const response = await safeApiCall(() => API.register(email, password, username));
                if (response) {
                    toast.success("Registration successful! Verify your email to log in.");
                    setRegistrationMode(false);

                }
            } catch (error) {
                toast.error("Unexcepted error during registration. Please try again.");
            }

        }
    }


    const login = async (e) => {
        e.preventDefault();
        try {
            const response = await safeApiCall(() => API.login(email, password), undefined);
            if (response){
                setUser("user",
                    JSON.stringify({
                    username: response.data.username,
                    isLoggedIn: true
                }),
                {
                    path: "/",
                    maxAge: 60 * 60 * 24 * 7
                })
                contextLogin({username: response.data.username,
                            isLoggedIn: true
                            });
                setLoginModalOpen(false);
            }
        }
        catch (error) {
            toast.error("Login failed. Please check your credentials and try again");
        }

    }

    function closeModal(evt){
        if (evt.target === evt.currentTarget){
            setLoginModalOpen(false);
        }
    }
    return (
        <div className="login-form-modal-overlay" onClick={evt => closeModal(evt)}>
            <ErrorBoundary>
                <div className="form-modal">
                    {!registrationMode ? (
                        <form onSubmit={login} className="login-form">
                            <h2>Log in</h2>
                            <div className="input-label-group">
                                <label htmlFor="login-email">E-mail:</label>
                                <input
                                    id="login-email"
                                    type="text"
                                    placeholder="E-mail"
                                    value = {email}
                                    onChange={evt => setEmail(evt.target.value)}
                                    className="form-input"
                                />
                            </div>
                            <div className="input-label-group">
                                <label htmlFor="login-password">Password:</label>
                                <input
                                    id="login-password"
                                    type="password"
                                    placeholder="Password"
                                    value = {password}
                                    onChange = {evt => setPassword(evt.target.value)}
                                    className="form-input"
                                />
                            </div>
                            <button type="submit" id="login-submit">Log in</button>
                        </form>
                    ) : (
                        <form className="login-form" onSubmit={handleRegistration}>
                            <h2>Sign up</h2>
                            <div className="input-label-group">
                                <label htmlFor="signup-username">Username:</label>
                                <input
                                    id="signup-username"
                                    type="text"
                                    placeholder="Username"
                                    value = {username}
                                    onChange={evt => setUsername(evt.target.value)}
                                    className="form-input"
                                />
                                {usernameError && <p className="input-error">{usernameError}</p>}
                            </div>
                            <div className="input-label-group">
                                <label htmlFor="signup-email">E-mail:</label>
                                <input
                                    id="signup-email"
                                    type="text"
                                    placeholder="E-mail"
                                    value = {email}
                                    onChange={evt => setEmail(evt.target.value)}
                                    className="form-input"
                                />
                                {emailError && <p className="input-error">{emailError}</p>}
                            </div>
                            <div className="input-label-group">
                                <label htmlFor="signup-confirm-email">Re-enter E-mail:</label>
                                <input
                                    id="signup-confirm-email"
                                    type="text"
                                    placeholder="Re-enter E-mail"
                                    value = {confirmEmail}
                                    onChange = {evt => setConfirmEmail(evt.target.value)}
                                    className="form-input"
                                />
                                {emailMatchError && <p className="input-error">{emailMatchError}</p>}
                            </div>
                            <div className="input-label-group">
                                <label htmlFor="signup-password">Password:</label>
                                <input
                                    id="signup-password"
                                    type="password"
                                    placeholder="Password"
                                    value = {password}
                                    onChange = {evt => setPassword(evt.target.value)}
                                    className="form-input"
                                />
                                {passwordError && <p className="input-error">{passwordError}</p>}
                            </div>
                            <div className="input-label-group">
                                <label htmlFor="signup-confirm-password">Re-enter Password</label>
                                <input
                                    id="signup-confirm-password"
                                    type="password"
                                    placeholder="Re-enter Password"
                                    value = {confirmPassword}
                                    onChange = {evt => setConfirmPassword(evt.target.value)}
                                    className="form-input"
                                />
                                {passwordMatchError && <p className="input-error">{passwordMatchError}</p>}
                            </div>
                            <button type="submit" id="signup-submit">Sign up</button>
                            
                        </form>
                    )}
                    {!registrationMode ? (
                        <p className="form-modal-text-switcher">Don't have an account? <span className="red-text-glow" onClick={() => {setRegistrationMode(true);}}>Sign up</span></p>
                    ) : (
                        <p className="form-modal-text-switcher">Already have an account? <span className="violet-text-glow" onClick={() => {setRegistrationMode(false);}}>Log in</span></p>
                    )}
                </div>
            </ErrorBoundary>
        </div>
    )
}